<nav class="navbar navbar-expand-lg top-sub-menu py-3">
    <div class="container-fluid">
        @if (this.router.url === '/customers' || this.router.url === '/customer-create') {
        <span class="fs-5 fw-bold"><i class="fas fa-users"></i> Kunder</span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                <li class="mx-2">
                    <a href="#" (click)="modalService.showCreateCustomer($event)"
                        class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-plus fa-xs"></i><i class="fas fa-user"></i> Opret Kunde
                    </a>
                </li>
                <!-- <li class="mx-2">
                        <a href="#" class="menu-item nav-link px-1 link-dark">
                            <i class="fas fa-plus fa-xs"></i><i class="fas fa-table"></i> Opret Regnskab
                        </a>
                    </li> -->
            </ul>
        </div>
        } @else if (this.router.url === '/home') {
        <span class="fs-5 fw-bold"><i class="fas fa-gauge-max"></i> Dashboard</span>
        <!-- @if (!currentUser.isAdmin) {
                <span class="fs-5"><span class="fs-5 fw-bold">:</span> {{currentUser.departmentName}} - [{{currentUser.departmentCode}}]</span>
            } -->
        } @else if(this.router.url === '/customer-administration') {
        <span class="fs-5 fw-bold"><i class="fas fa-arrows-to-circle"></i> Administerer kunder</span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                <!-- Development er oprindelsen i miljøkæden og har intet forrige miljø at importere fra -->
                @if(environment !== 'Development') {
                <li class="mx-2">
                    <a href="#" (click)="openSharedDataImportModal($event)" class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-file-import"></i> Importer faste data
                    </a>
                </li>
                }
            </ul>
        </div>
        } @else if(this.router.url.indexOf('/customer-dashboard/') === 0)
        {
        <span class="fs-5 fw-bold"><i class="fas fa-arrows-to-circle"></i> Kunde-dashboard</span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                <li class="mx-2">
                    <a href="#" (click)="modalService.showCopyCustomer($event)"
                        class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-cog"></i> Importer Opsætning
                    </a>
                </li>
                <li class="mx-2">
                    <a href="#" (click)="modalService.showAdminAccessModal($event)"
                        class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-user-tie"></i> Administrator adgang
                    </a>
                </li>
                <li class="mx-2">
                    <a href="#" (click)="modalService.showDeleteCustomer($event)"
                        class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-trash-can"></i> Slet kunde
                    </a>
                </li>
            </ul>
        </div>
        } @else if(this.router.url === '/companies') {
        <span class="fs-5 fw-bold"><i class="fas fa-table"></i> Regnskaber</span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                <li class="mx-2">
                    <a href="#" class="menu-item nav-link px-1 link-dark" (click)="createCompany($event)">
                        <i class="fas fa-plus fa-xs"></i><i class="fas fa-rotate"></i> Opret regnskab
                    </a>
                </li>
            </ul>
        </div>

        } @else if(this.router.url === '/templates') {
        <span class="fs-5 fw-bold"><i class="fas fa-right-left"></i>
            {{ isAdminUser == true ? 'Skabeloner for afdelingen' : 'Skabeloner' }} </span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                <li class="mx-2">
                    <a href="#" (click)="modalService.showCreateTemplate($event)"
                        class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-plus fa-xs"></i><i class="fas fa-right-left"></i> Opret Skabelon
                    </a>
                </li>
            </ul>
        </div>
        }

        @else if(this.router.url === '/db-templates')
        {
        <span class="fs-5 fw-bold"><i class="fa-regular fa-database"></i> Databaseskabeloner</span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                <li class="mx-2">
                    <a href="#" (click)="modalService.showCopyDbTemplate($event)"
                        class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-copy"></i> Kopier databaseskabelon
                    </a>
                </li>
                <li class="mx-2">
                    <a href="#" (click)="modalService.showCreateTemplatefromDb($event)"
                        class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-plus fa-xs"></i><i class="fas fa-database"></i> Opret databaseskabelon
                    </a>
                </li>
            </ul>
        </div>

        }
        @else if(isSynchronizationSection()) {
        <span class="fs-5 fw-bold me-4"><i class="fas fa-rotate"></i> Synkroniseringer</span>

        <ul class="nav nav-pills sub-tabs gap-1">
            <li class="nav-item">
                <a class="nav-link sub-tab" routerLink="/synchronizations" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <i class="fas fa-list-ul me-1"></i> Oversigt
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link sub-tab" routerLink="/synchronizations/monitoring" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <i class="fas fa-wave-pulse me-1"></i> Overvågning
                </a>
            </li>
        </ul>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                @if (isSynchronizationListTab()) {
                <li class="mx-2">
                    <a href="#" (click)="createSync($event)" class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-plus fa-xs"></i><i class="fas fa-rotate"></i> Opret Synkronisering
                    </a>
                </li>
                }
            </ul>
        </div>
        }
        @else if(this.router.url === '/synchronization-headquarter') {
        <span class="fs-5 fw-bold"><i class="fas fa-building-flag"></i> Synkroniseringer HQ</span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                <li class="mx-2">
                    <a href="#" (click)="downloadConsoleApp($event)" class="menu-item nav-link px-1 link-dark">
                        <i class="fas fa-file-arrow-down"></i> Download Sync. Console App
                    </a>
                </li>
            </ul>
        </div>
        }
        @else if(this.router.url === '/events') {
        <span class="fs-5 fw-bold"><i class="fas fa-calendar-days"></i> Hændelser (Sidste 30 dage)</span>
        }
        @else if(this.router.url === '/resourceaccess') {
        <span class="fs-5 fw-bold"><i class="fa-solid fa-user-lock"></i> Adgange</span>
        }
        @else if(this.router.url === '/profile') {
        <span class="fs-5 fw-bold"><i class="fas fa-user"></i> Profil</span>
        }
        @else if(this.router.url === '/translations') {
        <span class="fs-5 fw-bold"><i class="fas fa-book"></i> Sproglag</span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                @if(environment !== 'Development') {
                <li class="mx-2">
                    <a href="#" (click)="openTranslationsImportModal($event)" class="menu-item nav-link px-1 link-dark">
                        Importer Sproglag <i class="fas fa-calendar-arrow-down"></i> Sidst Hentet: {{latestImportDate | date:'dd-MM-yyyy'}}
                    </a>
                </li>
                }
            </ul>
        </div>
        }
        @else if(isAdminDashboard()) {
            <span class="fs-5 fw-bold"><i class="fas fa-building-flag"></i> Admin Dashboard</span>
            }
    
        <button class="navbar-toggler border-0 navbar-toggle-btn" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <i class="fas fa-bars"></i>
        </button>
    </div>
</nav>